import { useState } from 'react';
import { ClientEventsTable } from './ClientEventsTable';
import { AdminEventsTable } from './AdminEventsTable';
import { usePermissions } from '@/hooks/usePermissions';

type Tab = 'client' | 'admin';

/** У вкладок разные права — 1:1 permission() двух Orchid-экранов. */
const TABS: { key: Tab; label: string; permission: string }[] = [
  { key: 'client', label: 'Журнал событий ЛК', permission: 'platform*.events.list' },
  { key: 'admin', label: 'Журнал событий админки', permission: 'platform.admin.events' },
];

/**
 * Журнал событий — 1:1 старые Orchid-экраны app/Orchid/Screens/Event/*.php:
 * EventListScreen (ЛК — история действий в клиентских кабинетах) и
 * EventListAdminScreen (админка — история действий самих админов). Разные
 * таблицы/права/наборы полей на бэке — две вкладки, не общий компонент
 * (тот же приём, что "Тесты"/"Моношкальные тесты" в TestsCatalogPage.tsx).
 */
export function EventsPage() {
  const { can } = usePermissions();
  // Недоступную вкладку не показываем: журналы ЛК и админки — разные права.
  const tabs = TABS.filter((t) => can(t.permission));
  const [tab, setTab] = useState<Tab>(tabs[0]?.key ?? 'client');

  return (
    <section className="catalog">
      <header className="catalog__header">
        <h1>Журналы событий</h1>
        <p className="catalog__lede">Что, где, когда и кто делал в системе.</p>
      </header>

      <div className="card tabs">
        <div className="tabs__list" role="tablist">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={tab === t.key}
              className={`tabs__item${tab === t.key ? ' tabs__item--active' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="tabs__panel" role="tabpanel">
          {tab === 'client' ? <ClientEventsTable key="client" /> : <AdminEventsTable key="admin" />}
        </div>
      </div>
    </section>
  );
}
